function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M251.291,291.064c1.859-1.859,2.93-4.439,2.93-7.069c0-2.63-1.07-5.21-2.93-7.07c-1.86-1.86-4.431-2.93-7.07-2.93 c-2.63,0-5.21,1.069-7.07,2.93c-1.859,1.86-2.93,4.44-2.93,7.07c0,2.63,1.07,5.21,2.93,7.069c1.86,1.86,4.44,2.931,7.07,2.931 S249.431,292.925,251.291,291.064z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M473.997,217.997h-24.111c-14.207-29.552-44.441-49.999-79.363-49.999s-65.156,20.448-79.363,49.999H38.004 c-20.953,0-37.999,17.047-37.999,37.999s17.047,37.999,37.999,37.999h160.33c5.522,0,10-4.478,10-10c0-5.522-4.478-10-10-10H38.004 c-9.925,0-18-8.075-18-18s8.075-18,18-18h246.374c-1.213,5.813-1.854,11.833-1.854,18c0,48.522,39.476,87.999,87.999,87.999 c34.921,0,65.156-20.448,79.363-49.999h24.111c20.953,0,37.999-17.047,37.999-37.999S494.95,217.997,473.997,217.997z  M370.523,323.995c-37.494,0-67.999-30.505-67.999-67.999s30.505-67.999,67.999-67.999s67.999,30.505,67.999,67.999 S408.017,323.995,370.523,323.995z M473.997,273.996h-17.329c1.213-5.813,1.854-11.833,1.854-18s-0.641-12.188-1.854-18h17.329 c9.925,0,18,8.075,18,18C491.997,265.921,483.922,273.996,473.997,273.996z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M473.997,386.119H245.643c-14.183-29.614-44.45-50.116-79.418-50.116s-65.235,20.503-79.418,50.116H38.004 c-20.953,0-37.999,17.047-37.999,37.999s17.047,37.999,37.999,37.999h48.912C101.146,491.606,131.348,512,166.224,512 s65.078-20.394,79.308-49.882h228.464c20.953,0,37.999-17.047,37.999-37.999S494.95,386.119,473.997,386.119z M38.004,442.118 c-9.925,0-18-8.075-18-18s8.075-18,18-18h42.05c-1.197,5.776-1.828,11.757-1.828,17.883c0,6.209,0.65,12.268,1.879,18.117H38.004z  M166.225,492c-37.494,0-67.999-30.505-67.999-67.999s30.505-67.999,67.999-67.999s67.999,30.505,67.999,67.999 S203.719,492,166.225,492z M473.997,442.118H252.344c1.229-5.849,1.879-11.908,1.879-18.117c0-6.126-0.631-12.107-1.828-17.883 h221.602c9.925,0,18,8.075,18,18S483.922,442.118,473.997,442.118z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M348.999,69.999c2.63,0,5.21-1.07,7.069-2.931c1.86-1.859,2.931-4.439,2.931-7.069c0-2.63-1.07-5.21-2.931-7.07 c-1.859-1.86-4.439-2.93-7.069-2.93c-2.63,0-5.21,1.069-7.07,2.93c-1.86,1.861-2.93,4.44-2.93,7.07c0,2.63,1.069,5.21,2.93,7.069 C343.789,68.929,346.369,69.999,348.999,69.999z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M38.004,125.998h48.857c14.207,29.552,44.441,49.999,79.363,49.999s65.156-20.448,79.363-49.999h228.409 c20.953,0,37.999-17.047,37.999-37.999s-17.047-37.999-37.999-37.999h-88.499c-5.522,0-10,4.478-10,10c0,5.522,4.478,10,10,10 h88.499c9.925,0,18,8.075,18,18s-8.075,18-18,18H252.37c1.213-5.813,1.854-11.833,1.854-18c0-6.167-0.641-12.188-1.854-18H307 c5.522,0,10-4.478,10-10s-4.478-10-10-10h-61.412C231.381,20.448,201.146,0,166.225,0s-65.156,20.448-79.363,49.999H38.004 c-20.953,0-37.999,17.047-37.999,37.999S17.051,125.998,38.004,125.998z M166.225,20c37.494,0,67.999,30.505,67.999,67.999 s-30.505,67.999-67.999,67.999s-67.999-30.505-67.999-67.999S128.729,20,166.225,20z M38.004,69.999h42.075 c-1.213,5.813-1.854,11.833-1.854,18c0,6.167,0.641,12.188,1.854,18H38.004c-9.925,0-18-8.075-18-18S28.079,69.999,38.004,69.999z"
});

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

var _ref19 = /*#__PURE__*/React.createElement("g", null);

var _ref20 = /*#__PURE__*/React.createElement("g", null);

var _ref21 = /*#__PURE__*/React.createElement("g", null);

function SvgSliderTool(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D7E6"
    },
    d: "M473.997,59.999H38.004c-15.464,0-28,12.536-28,28l0,0c0,15.464,12.536,28,28,28h435.993 c15.464,0,28-12.536,28-28l0,0C501.997,72.535,489.461,59.999,473.997,59.999z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D7E6"
    },
    d: "M473.997,227.996H38.004c-15.464,0-28,12.536-28,28l0,0c0,15.464,12.536,28,28,28h435.993 c15.464,0,28-12.536,28-28l0,0C501.997,240.532,489.461,227.996,473.997,227.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D7D7E6"
    },
    d: "M473.997,395.994H38.004c-15.464,0-28,12.536-28,28l0,0c0,15.464,12.536,28,28,28h435.993 c15.464,0,28-12.536,28-28l0,0C501.997,408.53,489.461,395.994,473.997,395.994z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FF5A5A"
    },
    cx: 370.525,
    cy: 255.996,
    r: 77.999
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F5C86E"
    },
    cx: 166.228,
    cy: 87.999,
    r: 77.999
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#A5DC69"
    },
    cx: 166.228,
    cy: 424.003,
    r: 77.999
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderTool);
export default __webpack_public_path__ + "static/media/slider-tool.6bd40577.svg";
export { ForwardRef as ReactComponent };